import { post, put, del, get, patch } from 'aws-amplify/api';
import { processResponse } from './api_util';
import useSWR, {mutate} from 'swr'
import { handleApiResponse } from './api_util';

async function getCaseDetails() {

  const payload = {
    apiName: 'LivisiblyCaseDetailsApi',
    path: 'case_details'

  }

  const restOperation = get(payload);


  const response = await restOperation.response;

  return processResponse(response)
}


export function useGetCaseDetails(shouldFetch = true, options = {}) {
  const defaultOptions = {
    revalidateOnFocus: false,
    revalidateOnReconnect: false,
    refreshInterval: 0,
    dedupingInterval: 10000,
  };

  const result = useSWR(
    shouldFetch ? 'CASE_DETAILS' : null,
    (path) => getCaseDetails(),
    { ...defaultOptions, ...options }
  );
  return result;
}


const updateCaseDetails = async (updates) => {
  console.log('updateCaseDetails')
  console.log(JSON.stringify(updates, null, 2))

  const payload = {
    apiName: 'LivisiblyCaseDetailsApi',
    path: `case_details`,
    options: {
      body: {
        case_detail_data: updates,
      }
    }
  }
  console.log(`posting payload: ${JSON.stringify(payload)}`)
  const restOperation = post(payload);


  const response = await restOperation.response;
  return processResponse(response)
};

export const useUpdateCaseDetails = () => {
  return async (updates) => {
    try {
      await updateCaseDetails(updates);
    } finally {
      // Revalidate the cache after the mutation completes
      mutate(`CASE_DETAILS`);
    }
  };
}


const patchCaseDetails = async (updates) => {
  console.log('patchCaseDetails')
  console.log(JSON.stringify(updates, null, 2))

  const payload = {
    apiName: 'LivisiblyCaseDetailsApi',
    path: `case_details`,
    options: {
      body: {
        case_detail_data: updates,
      }
    }
  }
  console.log(`patching payload: ${JSON.stringify(payload)}`)
  const restOperation = patch(payload);


  const response = await restOperation.response;
  return processResponse(response)
};

export const usePatchCaseDetails = () => {
  return (updates) => {
    const options = {
      optimisticData: updates, // Optimistically update the cache
      revalidate: true,  // Don't revalidate immediately because the mutation will return the updated data
    }
    mutate(`CASE_DETAILS`,
      patchCaseDetails(updates) // Call the update function
      , options);
  };
}